<mat-drawer-container autosize>
  <mat-drawer position="start"
    mode="side"
    opened
    class="list-density-settings-3">
    <mat-nav-list>

      <div class="zone-container">
        <div mat-subheader>Zone</div>
        <mat-list-item class="zone no-list-item-highlight"
          disableRipple="true">
          <mat-form-field appearance="fill">
            <mat-label></mat-label>
            <mat-select (selectionChange)="changeZone($event)" multiple>
              @for (zone of zones; track zone) {
                <mat-option
                  [value]="zone.getId()">
                  {{zone.getLabel()}}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </mat-list-item>
        <mat-divider></mat-divider>
      </div>

      <div class="dienst-container">
        <div mat-subheader>Dienst</div>
        <mat-list-item class="dienst no-list-item-highlight"
          disableRipple="true">
          <mat-form-field appearance="fill">
            <mat-label></mat-label>
            <mat-select (selectionChange)="changeDienst($event)" multiple>
              @for (dienst of diensten; track dienst) {
                <mat-option
                  [value]="dienst.getId()">
                  {{dienst.getLabel()}}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </mat-list-item>
        <mat-divider></mat-divider>
      </div>

      <div mat-subheader
        class="clickable"
        (click)="toggleTeVerwerken()">
        Ongelezen
        <mat-icon>{{isTeVerwerkenOpen() ? 'expand_less' : 'expand_more'}}</mat-icon>
      </div>
      @if (isTeVerwerkenOpen()) {
        <div
          class="verwerkingsstatus"
          [class.open]="isTeVerwerkenOpen()">
          @if (activiteitenPage?.isEmpty()) {
            <mat-list-item
              class="no-list-item-highlight"
              disableRipple>
              Geen ongelezen activiteiten
            </mat-list-item>
          }
          <div class="activiteiten">
            @for (activiteit of activiteitenPage?.getItems(); track getActiviteitId($index, activiteit)) {
              <zah-activiteit-list-item
                [activiteit]="activiteit"
                [client]="activiteitenPage.getClient(activiteit.getClientId())"
                [auteur]="activiteitenPage.getAuteur(activiteit.getAuteurId())"
                [zones]="zones"
                (click)="selectActiviteit(activiteit)"
                [class.active]="selectedActiviteit?.hasId(activiteit.getId())">
              </zah-activiteit-list-item>
            }
          </div>
          <zah-mini-paginator [pageSize]="currentPageRequest.getPageSize()"
            [sortOrder]="currentPageRequest.getSortOrder()"
            [currentPage]="activiteitenPage"
            (pageSizeChange)="onPageSizeChange($event)"
            (sortOrderChange)="onSortOrderChange($event)"
            (pageChange)="onPageChange($event)">
          </zah-mini-paginator>
        </div>
      }

      <mat-divider></mat-divider>
      <div mat-subheader
        class="clickable"
        (click)="toggleGeschiedenis()">
        Geschiedenis
        <mat-icon>{{isGeschiedenisOpen() ? 'expand_less' : 'expand_more'}}</mat-icon>
      </div>
      @if (isGeschiedenisOpen()) {
        <div
          class="verwerkingsstatus"
          [class.open]="isGeschiedenisOpen()">
          @if (activiteitenPage?.isEmpty()) {
            <mat-list-item
              class="no-list-item-highlight"
              disableRipple>
              Geen activiteiten geschiedenis
            </mat-list-item>
          }
          <div class="activiteiten">
            @for (activiteit of activiteitenPage?.getItems(); track getActiviteitId($index, activiteit)) {
              <zah-activiteit-list-item
                [activiteit]="activiteit"
                [client]="activiteitenPage.getClient(activiteit.getClientId())"
                [auteur]="activiteitenPage.getAuteur(activiteit.getAuteurId())"
                [zones]="zones"
                (click)="selectActiviteit(activiteit)"
                [class.active]="selectedActiviteit?.hasId(activiteit.getId())">
              </zah-activiteit-list-item>
            }
          </div>
          <zah-mini-paginator [pageSize]="currentPageRequest.getPageSize()"
            [sortOrder]="currentPageRequest.getSortOrder()"
            [currentPage]="activiteitenPage"
            (pageSizeChange)="onPageSizeChange($event)"
            (sortOrderChange)="onSortOrderChange($event)"
            (pageChange)="onPageChange($event)">
          </zah-mini-paginator>
        </div>
      }
    </mat-nav-list>
  </mat-drawer>
  <mat-drawer-content>
    <ng-content></ng-content>
  </mat-drawer-content>
</mat-drawer-container>
